import { required, dataMember, typedArray } from 'santee-dcts';

export class InvestigatorEQueryCounter {
    @required()
    @dataMember()
    public siteId: number;

    @required()
    @dataMember()
    @typedArray(Number)
    public totalUnresolved: number[];

    @required()
    @dataMember()
    public total: number;
}

export class InvestigatorEQueryReadModel {
    @required()
    @dataMember()
    @typedArray(InvestigatorEQueryCounter)
    public counters: InvestigatorEQueryCounter[];
}